module.exports = __webpack_public_path__ + "img/tabbar_button_tex.7227848c.png";